import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import './adminDashboard.css';
import CohortManagement from "./CohortManagement";
import CohortReports from "./CohortReports";

export default function InstructorGrid() {  // Changed name
    const classes = {
        root: 'ad-root',
        sidebar: 'ad-sidebar',
        menuItem: 'ad-menuItem',
        mainContent: 'ad-mainContent',
        formControl: 'ad-formControl',
        button: 'ad-button',
        table: 'ad-table',
        tableContainer: 'ad-tableContainer',
        tableHead: 'ad-tableHead',
        tableCell: 'ad-tableCell',
        error: 'ad-error',
        pagination: 'ad-pagination',
        tableRow: 'ad-tableRow',
    };

    const [activeTab, setActiveTab] = useState(0);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [authChecked, setAuthChecked] = useState(false);
    const history = useHistory();

    useEffect(() => {
        checkAuthorization();
    }, []);

    const checkAuthorization = async () => {
        try {
            const response = await fetch('/api/auth/me', {  // Changed to /api/auth/me
                method: 'GET',
                credentials: 'include',
            });

            if (!response.ok) {
                setIsAuthorized(false);
                setAuthChecked(true);
                history.push('/login');
                return;
            }

            const userData = await response.json();
            console.log('User data from /api/auth/me:', userData); // Debug log

            // Allow professors and admins
            const allowedRoles = ['professor', 'admin'];
            const hasAccess = allowedRoles.includes(userData.globalRole);

            setIsAuthorized(hasAccess);

            // Redirect students to their profile
            if (!hasAccess && userData.globalRole === 'student') {
                history.push('/profile');
            }
        } catch (error) {
            console.error('Error checking authorization:', error);
            setIsAuthorized(false);
            history.push('/login');
        } finally {
            setAuthChecked(true);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    if (!authChecked) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <Typography variant="h6">Checking authorization...</Typography>
            </Box>
        );
    }

    if (!isAuthorized) {
        return (
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" p={4}>
                <Typography variant="h5" gutterBottom>
                    Access Denied
                </Typography>
                <Typography variant="body1" align="center" color="textSecondary">
                    You are not authorized to view this page. This page is only accessible to professors and administrators.
                </Typography>
            </Box>
        );
    }

    return (
        <div style={{ backgroundColor: '#f5f8f5', minHeight: '100vh', padding: '24px' }}>
            <Box maxWidth="1440px" margin="auto">
                <Typography variant="h4" align="center" gutterBottom style={{ marginBottom: 24 }}>
                    Instructor Portal
                </Typography>

                <Paper className={classes.tableContainer}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                    >
                        <Tab label="Cohort Management" />
                        <Tab label="Cohort Reports" />
                    </Tabs>

                    <Box p={3}>
                        {activeTab === 0 && <CohortManagement classes={classes} />}
                        {activeTab === 1 && <CohortReports classes={classes} />}
                    </Box>
                </Paper>
            </Box>
        </div>
    );
}
